import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';
import { getDataAttribute } from 'epic-common/src/browser';

@pureRender
class Legal extends React.Component {
    static propTypes = {
        logos: PropTypes.array,
        tos: PropTypes.string,
        privacy: PropTypes.string,
        moreLegalLinks: PropTypes.array,
        hideDefaultTermsPolicy: PropTypes.bool
    };

    onClick = (e) => {
        const index = getDataAttribute(e.currentTarget, 'index');
        const link = this.props.moreLegalLinks[index];
        if (link && link.onClick && typeof link.onClick === 'function') {
            link.onClick(e);
        }
    };

    render() {
        const tos = this.props.tos || '';
        const privacy = this.props.privacy || '';
        const logos = this.props.logos || [];
        const moreLegalLinks = this.props.moreLegalLinks || [];
        const hideDefaultTermsPolicy = this.props.hideDefaultTermsPolicy;
        const termsPolicy = [];
        termsPolicy.push(
            <li key="terms">
                <a
                    id="footerTerms"
                    className="text-color accent-color-hover"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="http://epicgames.com/tos">
                    {tos}
                </a>
            </li>
        );
        termsPolicy.push(
            <li key="divider"><span className="text-color">{ tos && privacy ? '|' : '' }</span></li>
        );
        termsPolicy.push(
            <li key="policy">
                <a
                    id="footerPrivacy"
                    className="text-color accent-color-hover"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="http://epicgames.com/privacypolicy">
                    {privacy}
                </a>
            </li>
        );
        return (
            <div>
                <div className="col-xs-12 col-sm-6 legal">
                    <ul className="links">
                        {hideDefaultTermsPolicy ? '' : termsPolicy}
                        {
                            moreLegalLinks.map((legalLink, i) => {
                                return (
                                    <li key={`more-legal-link-${legalLink.title}`}>
                                        { (!hideDefaultTermsPolicy && tos && privacy) || (hideDefaultTermsPolicy && i !== 0) ?
                                            <span className="text-color more-legal-link-separator">|</span> : '' }
                                        <a
                                            onClick={this.onClick}
                                            className="text-color accent-color-hover"
                                            target={legalLink.target}
                                            data-index={i}
                                            rel="noopener noreferrer"
                                            href={legalLink.href}>
                                            {legalLink.title}
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
                <div className="col-xs-12 col-sm-6 legal">
                    <ul className="logos">
                        {
                            logos.map((logo, i) => {
                                const isLink = !!logo.href;
                                const id = logo.id ? logo.id : logo;
                                const href = logo.href;
                                const title = logo.title || '';
                                const icon = <i title={title} className={`text-color-nonactive eg-footer-icon-${id}`} />;
                                return (
                                    <li key={`listitem-${id}`}>
                                        {isLink ? (
                                            <a href={href} title={title} target="_blank" rel="noopener noreferrer">{icon}</a>
                                        ) : icon}
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

export default Legal;



// WEBPACK FOOTER //
// ./app/scripts/components/legal/Legal.js